import React, { useState, useCallback, useEffect } from "react";
import data from "../../femcare-content.json";

const { testimonials } = data.sections;

const BREAKPOINTS = {
  mobile: 1,
  tablet: 2,
  desktop: 4,
};

const getVisibleCount = (width) => {
  if (width < 640) return BREAKPOINTS.mobile;
  if (width < 1024) return BREAKPOINTS.tablet;
  return BREAKPOINTS.desktop;
};

const Testimonials = () => {
  const { id, heading, backgroundImage, items } = testimonials;

  const [startIndex, setStartIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(() =>
    getVisibleCount(window.innerWidth),
  );

  useEffect(() => {
    const onResize = () => {
      const next = getVisibleCount(window.innerWidth);
      setVisibleCount((prev) => {
        if (prev !== next) setStartIndex(0);
        return next;
      });
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const maxStart = Math.max(0, items.length - visibleCount);
  const canPrev = startIndex > 0;
  const canNext = startIndex < maxStart;

  const visibleItems = items.slice(startIndex, startIndex + visibleCount);

  // ✅ FIXED: Works for mobile, tablet, desktop
  const showArrows = items.length > visibleCount;

  const handlePrev = useCallback(() => {
    if (canPrev) setStartIndex((i) => i - 1);
  }, [canPrev]);

  const handleNext = useCallback(() => {
    if (canNext) setStartIndex((i) => i + 1);
  }, [canNext]);

  return (
    <section
      id={id}
      className="relative w-full overflow-hidden ava-section-gap"
      style={{ minHeight: "420px" }}
    >
      {/* <img
        src={backgroundImage}
        alt="Stories background"
        className="absolute inset-0 w-full h-full object-cover object-center"
        draggable={false}
      /> */}

      <div
        className="absolute inset-0 secondary-bg"
      // style={{ backgroundColor: "#595E86C9" }}
      />

      {/* <div className="relative z-10 container mx-auto px-4 md:px-8 py-10 md:py-14">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <h2
            className=" ava-heading-lg ava-black-text  "
            style={{
              // fontSize: "clamp(1.2rem, 2.8vw, 1.85rem)",
              textShadow: "0 1px 6px rgba(0,0,0,0.18)",
            }}
          >
            {heading}
          </h2>

        
          {showArrows && (
            <div className="flex items-center gap-2 flex-shrink-0 ml-4">
              <ArrowBtn
                onClick={handlePrev}
                disabled={!canPrev}
                direction="left"
              />
              <ArrowBtn
                onClick={handleNext}
                disabled={!canNext}
                direction="right"
              />
            </div>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4  ava-card-gap">
          {visibleItems.map((item) => (
            <TestimonialCard key={item.id} item={item} />
          ))}
        </div>
      </div> */}
      {/* Replace the cards + arrows layout in your return statement */}

<div className="relative z-10 container mx-auto px-4 md:px-8 py-10 md:py-14">
  <div className="ava-heading-gap">
    <h2
      className="ava-heading-lg ava-black-text"
      style={{ textShadow: "0 1px 6px rgba(0,0,0,0.18)" }}
    >
      {heading}
    </h2>
  </div>

  {/* Carousel wrapper — arrows overlap the card edges */}
  <div style={{ position: "relative" }}>

    {/* LEFT arrow — half outside the card area */}
    {showArrows && (
      <button
        onClick={handlePrev}
        disabled={!canPrev}
        aria-label="Previous testimonials"
        style={{
          position: "absolute",
          left: "-20px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 20,
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          backgroundColor: "white",
          border: "1px solid #e5e7eb",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: canPrev ? "pointer" : "not-allowed",
          opacity: canPrev ? 1 : 0.4,
          boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
          border:"1px solid var(--primary-color)"
        }}
      >
        <img src="/images/left-arrow.svg" alt="left" style={{ width: "2.5rem", height: "2.5rem" }} />
      </button>
    )}

    {/* Cards grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 ava-card-gap">
      {visibleItems.map((item) => (
        <TestimonialCard key={item.id} item={item} />
      ))}
    </div>

    {/* RIGHT arrow — half outside the card area */}
    {showArrows && (
      <button
        onClick={handleNext}
        disabled={!canNext}
        aria-label="Next testimonials"
        style={{
          position: "absolute",
          right: "-20px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 20,
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          backgroundColor: "white",
          border: "1px solid #e5e7eb",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: canNext ? "pointer" : "not-allowed",
          opacity: canNext ? 1 : 0.4,
          boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
          border:"1px solid var(--primary-color)"
        }}
      >
        <img src="/images/right-arrow.svg" alt="right" style={{ width: "2.5rem", height: "2.5rem" }} />
      </button>
    )}
  </div>
</div>
    </section>
  );
};

/* Arrow button */
const ArrowBtn = ({ onClick, disabled, direction }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    aria-label={
      direction === "left" ? "Previous testimonials" : "Next testimonials"
    }
    className="w-10 h-10 flex items-center justify-center rounded-full bg-white border transition-all duration-200"
    style={{ cursor: disabled ? "not-allowed" : "pointer" }}
  >
    <img
      src={
        direction === "left"
          ? "/images/left-arrow.svg"
          : "/images/right-arrow.svg"
      }
      alt={direction}
      className="w-10 h-10"
    />
  </button>
);

/* Card */
// const TestimonialCard = ({ item }) => (
//   <div
//     className="flex flex-col justify-between rounded-2xl p-5 ava-card-bg"
//     style={{
//       // backgroundColor: "rgba(255,255,255,0.82)",
//       backdropFilter: "blur(8px)",
//       WebkitBackdropFilter: "blur(8px)",
//       boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
//       minHeight: "220px",
//     }}
//   >
//     <p className="ava-text-body mb-6 flex-1 primary-text">
//       {item.review}
//     </p>

//     <div
//       className="flex items-center gap-3 rounded-xl px-3 py-2"
//       style={{ backgroundColor: "var(--primary-color)" }}
//     >
//       <div
//         className="flex-shrink-0 rounded-full overflow-hidden border-2 border-white"
//         style={{ width: "38px", height: "38px" }}
//       >
//         {item.avatar ? (
//           <img
//             src={item.avatar}
//             alt={item.name}
//             className="w-full h-full object-cover object-center"
//             draggable={false}
//           />
//         ) : (
//           <div
//             className="w-full h-full flex items-center justify-center text-white font-bold text-sm"
//             style={{ backgroundColor: "rgba(255,255,255,0.25)" }}
//           >
//             {item.name.charAt(0)}
//           </div>
//         )}
//       </div>

//       <div>
//         <p className="text-white ava-text-subheading ">
//           {item.name}
//         </p>
//         {item.age && (
//           <p
//             className="text-xs leading-tight"
//             style={{ color: "rgba(255,255,255,0.75)" }}
//           >
//             {item.age}
//           </p>
//         )}
//       </div>
//     </div>
//   </div>
// );
 export const VerifiedIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2l2.4 1.8 3-.6 1.2 2.8 2.8 1.2-.6 3L22 12l-1.8 2.4.6 3-2.8 1.2-1.2 2.8-3-.6L12 22l-2.4-1.8-3 .6-1.2-2.8-2.8-1.2.6-3L2 12l1.8-2.4-.6-3 2.8-1.2L7.2 2.6l3 .6L12 2z"
        fill="var(--ava-color-primary-400)"
      />
      <path
        d="M8.5 12.5l2.5 2.5 4.5-5"
        stroke="white"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

const TestimonialCard = ({ item }) => {
  const rating = item.rating ?? 4.8;

  const StarIcon = ({ size = 18, fill = "#F5A623", id }) => (
    <svg width={size} height={size} viewBox="0 0 24 24">
      {id && (
        <defs>
          <linearGradient id={id}>
            <stop offset="50%" stopColor="#F5A623" />
            <stop offset="50%" stopColor="#D6D0F7" />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
        fill={id ? `url(#${id})` : fill}
      />
    </svg>
  );


  return (
    <div
      className="ava-card-bg  ava-radius-md ava-card-mukta"
      style={{
        // borderRadius: "20px",
        padding: "20px",
        minHeight: "220px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        position: "relative",
        // borderBottom:"2.5px solid var(--ava-color-primary-300)"
      }}
    >
      {/* Decorative quote mark */}
      {/* <span
        style={{
          position: "absolute",
          top: "14px",
          right: "18px",
          fontSize: "72px",
          color: "#D6D0F7",
          lineHeight: 1,
          fontFamily: "Georgia, serif",
          pointerEvents: "none",
          userSelect: "none",
        }}
      >
        {'\u201D'}
      </span> */}

      <div>
        {/* Rating badge + stars */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "14px" }}>
          <div
            style={{
              backgroundColor: "var(--primary-color)",
              color: "#fff",
              fontSize: "13px",
              fontWeight: 500,
              padding: "5px 10px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <StarIcon size={12} fill="white" />
            {rating}
          </div>

          {/* <div style={{ display: "flex", gap: "2px", alignItems: "center" }}>
            {[1, 2, 3, 4, 5].map((i) => {
              const full = i <= Math.floor(rating);
              const half = !full && i - rating < 1;
              const halfId = `half-star-${i}`;
              return (
                <StarIcon
                  key={i}
                  size={18}
                  fill={full ? "#4B1528" : "#D6D0F7"}
                  id={half ? halfId : undefined}
                />
              );
            })}
          </div> */}
        </div>

        {/* Review text */}
        <div className="ava-review-scroll" style={{maxHeight:"148px",overflow:"auto"}} >
        <p className="ava-text-body"
          style={{
            marginBottom: "16px",
            position: "relative",
            zIndex: 1,
          }}
        >
          {item.review}
        </p>
        </div>
      </div>

      {/* Author row */}
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <div
          style={{
            width: "42px",
            height: "42px",
            borderRadius: "50%",
            overflow: "hidden",
            flexShrink: 0,
            border: "2.5px solid var(--ava-color-secondary-400)",
            backgroundColor: "#C9C2F5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {item.avatar ? (
            <img
              src={item.avatar}
              alt={item.name}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              draggable={false}
            />
          ) : (
            <span style={{ fontWeight: 500, fontSize: "15px", color: "var(--primary-color)" }}>
              {item.name.charAt(0)}
            </span>
          )}
        </div>

        <div>
          <div
            style={{
              fontWeight: 700,
              display: "flex",
              alignItems: "center",
              gap: "5px",
              color: "var(--primary-color)"
            }}
            className="ava-text-body"
          >
            {item.name}
            {item.verified !== false && <VerifiedIcon />}
          </div>
          {/* <div style={{ marginTop: "1px" }} className="ava-text-xs">
            {item.role ?? "Patient"}
          </div> */}
          <div
            className="ava-text-xs"
            style={{
              marginTop: "1px",
              color: "var(--ava-color-caption)"
            }}
          >
            {item.role ?? "Patient"}
            {item.timeAgo && ` • ${item.timeAgo}`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;






// import React, { useState, useCallback, useEffect } from "react";
// import data from "../../femcare-content.json";

// const { testimonials } = data.sections;

// // Visible count per breakpoint
// const BREAKPOINTS = {
//   mobile: 1, // < 640px
//   tablet: 2, // 640px – 1023px
//   desktop: 4, // ≥ 1024px
// };

// const getVisibleCount = (width) => {
//   if (width < 640) return BREAKPOINTS.mobile;
//   if (width < 1024) return BREAKPOINTS.tablet;
//   return BREAKPOINTS.desktop;
// };

// const Testimonials = () => {
//   const { id, heading, backgroundImage, items } = testimonials;
//   const [startIndex, setStartIndex] = useState(0);
//   const [visibleCount, setVisibleCount] = useState(() =>
//     getVisibleCount(window.innerWidth),
//   );

//   // Update visibleCount on resize and reset startIndex when count changes
//   useEffect(() => {
//     const onResize = () => {
//       const next = getVisibleCount(window.innerWidth);
//       setVisibleCount((prev) => {
//         if (prev !== next) setStartIndex(0); // reset to first card on breakpoint change
//         return next;
//       });
//     };
//     window.addEventListener("resize", onResize);
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   const maxStart = Math.max(0, items.length - visibleCount);
//   const canPrev = startIndex > 0;
//   const canNext = startIndex < maxStart;

//   const visibleItems = items.slice(startIndex, startIndex + visibleCount);

//   // NEW CONDITION (only for desktop)
//   const showArrows =
//     visibleCount === BREAKPOINTS.desktop && items.length > BREAKPOINTS.desktop;

//   const handlePrev = useCallback(() => {
//     if (canPrev) setStartIndex((i) => i - 1);
//   }, [canPrev]);

//   const handleNext = useCallback(() => {
//     if (canNext) setStartIndex((i) => i + 1);
//   }, [canNext]);

//   return (
//     <section
//       id={id}
//       className="relative w-full overflow-hidden"
//       style={{ minHeight: "420px" }}
//     >
//       {/* ── Background image ── */}
//       <img
//         src={backgroundImage}
//         alt="Stories background"
//         className="absolute inset-0 w-full h-full object-cover object-center"
//         draggable={false}
//       />

//       {/* ── Overlay ── */}
//       <div
//         className="absolute inset-0"
//         style={{ backgroundColor: "#595E86C9" }}
//       />

//       {/* ── Content ── */}
//       <div className="relative z-10 container mx-auto px-4 md:px-8 py-10 md:py-14">
//         {/* Header row — heading left, arrows right */}
//         <div className="flex items-center justify-between mb-8 md:mb-10">
//           <h2
//             className="font-bold text-white"
//             style={{
//               fontSize: "clamp(1.2rem, 2.8vw, 1.85rem)",
//               textShadow: "0 1px 6px rgba(0,0,0,0.18)",
//             }}
//           >
//             {heading}
//           </h2>

//           {/* ✅ Arrows ONLY on desktop + more than 4 cards */}
//           {showArrows && (
//             <div className="flex items-center gap-2 flex-shrink-0 ml-4">
//               <ArrowBtn
//                 onClick={handlePrev}
//                 disabled={!canPrev}
//                 direction="left"
//               />
//               <ArrowBtn
//                 onClick={handleNext}
//                 disabled={!canNext}
//                 direction="right"
//               />
//             </div>
//           )}
//         </div>

//         {/* ── Cards ──
//               Mobile:  1 col  (1 card at a time)
//               Tablet:  2 cols (2 cards at a time)
//               Desktop: 4 cols (4 cards at a time)
//         ── */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
//           {visibleItems.map((item) => (
//             <TestimonialCard key={item.id} item={item} />
//           ))}
//         </div>

//         {/* Mobile dot indicators */}
//         {/* {visibleCount === 1 && (
//           <div className="flex justify-center gap-1.5 mt-6">
//             {items.map((_, i) => (
//               <button
//                 key={i}
//                 onClick={() => setStartIndex(i)}
//                 aria-label={`Go to testimonial ${i + 1}`}
//                 className="rounded-full transition-all duration-300"
//                 style={{
//                   width:  i === startIndex ? 20 : 7,
//                   height: 7,
//                   backgroundColor: i === startIndex ? '#fff' : 'rgba(255,255,255,0.4)',
//                   border: 'none',
//                   cursor: 'pointer',
//                 }}
//               />
//             ))}
//           </div>
//         )} */}
//       </div>
//     </section>
//   );
// };

// /* ── Arrow button (unchanged) ── */
// const ArrowBtn = ({ onClick, disabled, direction }) => (
//   <button
//     onClick={onClick}
//     disabled={disabled}
//     aria-label={
//       direction === "left" ? "Previous testimonials" : "Next testimonials"
//     }
//     className="w-10 h-10 flex items-center justify-center rounded-full bg-white border transition-all duration-200"
//     style={{ cursor: disabled ? "not-allowed" : "pointer" }}
//   >
//     <img
//       src={
//         direction === "left"
//           ? "/images/left-arrow.svg"
//           : "/images/right-arrow.svg"
//       }
//       alt={direction}
//       className="w-10 h-10"
//     />
//   </button>
// );

// /* ── Testimonial card (unchanged) ── */
// const TestimonialCard = ({ item }) => (
//   <div
//     className="flex flex-col justify-between rounded-2xl p-5"
//     style={{
//       backgroundColor: "rgba(255,255,255,0.82)",
//       backdropFilter: "blur(8px)",
//       WebkitBackdropFilter: "blur(8px)",
//       boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
//       minHeight: "220px",
//     }}
//   >
//     {/* Quote text */}
//     <p className="text-sm leading-relaxed mb-6 flex-1 primary-text">
//       {item.review}
//     </p>

//     {/* Author row */}
//     <div
//       className="flex items-center gap-3 rounded-xl px-3 py-2"
//       style={{ backgroundColor: "var(--primary-color)" }}
//     >
//       {/* Avatar */}
//       <div
//         className="flex-shrink-0 rounded-full overflow-hidden border-2 border-white"
//         style={{ width: "38px", height: "38px" }}
//       >
//         {item.avatar ? (
//           <img
//             src={item.avatar}
//             alt={item.name}
//             className="w-full h-full object-cover object-center"
//             draggable={false}
//           />
//         ) : (
//           <div
//             className="w-full h-full flex items-center justify-center text-white font-bold text-sm"
//             style={{ backgroundColor: "rgba(255,255,255,0.25)" }}
//           >
//             {item.name.charAt(0)}
//           </div>
//         )}
//       </div>

//       {/* Name + age */}
//       <div>
//         <p className="text-white font-semibold text-sm leading-tight">
//           {item.name}
//         </p>
//         {item.age && (
//           <p
//             className="text-xs leading-tight"
//             style={{ color: "rgba(255,255,255,0.75)" }}
//           >
//             {item.age}
//           </p>
//         )}
//       </div>
//     </div>
//   </div>
// );

// export default Testimonials;
